import moment from "moment";
import {decriptMessage} from "./SecureData";
import {categoriesV2} from "./dictionaries/Categories";

export function isEmpty(obj) {
    for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
}

export function isEmptyJson(obj) {
    if (obj === null || obj === undefined) {
        return true;
    }
    return JSON.stringify(obj) === JSON.stringify({});
}

/**
 * Verifica che un oggetto abbia almeno una chiave a cui è associato un valore
 *
 * @param obj: oggetto della verifica
 * @returns {boolean}: vero se l'oggetto possiede almeno una proprietà, falso se al contrario è vuoto o con valori
 *   stringhe vuote
 */
export function checkProperties(obj) {
    for (let key in obj) {
        if (obj[key] !== null && obj[key] !== "") return true;
    }
    return false;
}

export function clean(obj) {
    for (let propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
            delete obj[propName];
        }
    }
    return obj
}

export function checkEquals(x, y) {
    const ok = Object.keys, tx = typeof x, ty = typeof y;
    return x && y && tx === "object" && tx === ty ? ok(x).length === ok(y).length && ok(x).every((key) => checkEquals(x[key], y[key])) : x === y;
}

export function checkEqualsAnagrafiche(a1, a2) {
    if (isEmpty(a1) || isEmpty(a2)) {
        return false;
    }
    return (a1.codF === a2.codF && a1.idSoggetto === a2.idSoggetto && a1.idCSI === a2.idCSI && a1.cognome === a2.cognome && a1.nome === a2.nome && a1.cell === a2.cell && a1.email === a2.email && a1.sesso === a2.sesso && a1.indirizzoDomicilio === a2.indirizzoDomicilio && a1.indirizzoResidenza === a2.indirizzoResidenza)
}

export function dicToArray(dictionary) {
    let array = [];
    Object.entries(dictionary).forEach(([key]) => {
        if (dictionary.hasOwnProperty(key)) {
            array.push(key);
        }
    });
    return array;
}

export function getUserNameAndSurname() {
    let usernameEncripted = sessionStorage.getItem("usr_asl_to");
    if (usernameEncripted) {
        let username = JSON.parse(decriptMessage(usernameEncripted));
        if (username) {
            return capitalizeWords(username.nome) + " " + capitalizeWords(username.cognome)
        }
    } else {
        return "Errore ... :(";
    }
}

export function getUserName() {
    let usernameEncripted = sessionStorage.getItem("usr_asl_to");
    if (usernameEncripted) {
        let username = JSON.parse(decriptMessage(usernameEncripted));
        if (username) {
            return capitalizeWords(username.nome)
        }
    } else {
        return "Errore ... :(";
    }
}

export function getUserEmail() {
    let usernameEncripted = sessionStorage.getItem("usr_asl_to");
    if (usernameEncripted) {
        let username = JSON.parse(decriptMessage(usernameEncripted));
        if (username) {
            return username.email
        }
    } else {
        return "Errore ... :(";
    }
}

export function getAccountInfo() {
    let infoEncripted = sessionStorage.getItem("inf_asl_to");
    if (infoEncripted) {
        let info = decriptMessage(infoEncripted);
        if (info) {
            return JSON.parse(info)
        }
    } else {
        return null
    }
}

export function getCompanyInfo() {
    let infoEncripted = sessionStorage.getItem("cmp_asl_to");
    if (infoEncripted) {
        let info = decriptMessage(infoEncripted);
        if (info) {
            return JSON.parse(info)
        }
    } else {
        return null
    }
}

export function getUserInfo() {
    let infoEncripted = sessionStorage.getItem("usr_asl_to");
    if (infoEncripted) {
        let user = decriptMessage(infoEncripted);
        if (user) {
            return JSON.parse(user)
        }
    } else {
        return null
    }
}

export function getKeyByValue(object, value) {
    return Object.keys(object).find(key => checkEquals(object[key].label, value));
}

export function getKeyByValueVal(object, value) {
    return Object.keys(object).find(key => checkEquals(object[key].val, value));
}

export function getKeyByValueInArray(array, value) {
    return array.find(item => checkEquals(item.label, value));
}

export function getKeyByValuePure(object, value) {
    return Object.keys(object).find(key => checkEquals(object[key], value));
}

export function capitalizeWords(str) {
    if (!str) {
        return "";
    }
    let splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
}

export function capitalizeFirstLetter(str) {
    if (!str) {
        return "";
    }
    let splitStr = str?.toLowerCase()?.split(' ');
    splitStr[0] = splitStr[0]?.charAt(0)?.toUpperCase() + splitStr[0]?.substring(1);
    return splitStr?.join(' ');
}

export function filterByText(value, tamponi) {
    return tamponi.filter(t => t.codF === value || moment(t.dataEsito).format("DD/MM/YYYY") || t.laboratorio === value || t.medicoRichiedente === value)
}

export const camelToSnakeCase = (str) => {
    if (str === "codF") {
        return str;
    }
    return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
};

export function genCharArray(charA, charZ) {
    let a = [], i = charA.charCodeAt(0), j = charZ.charCodeAt(0);
    for (; i <= j; ++i) {
        a.push(String.fromCharCode(i));
    }
    return a;
}

export function formatBytes(a, b = 2) {
    if (0 === a) return "0 Bytes";
    const c = 0 > b ? 0 : b, d = Math.floor(Math.log(a) / Math.log(1024));
    return parseFloat((a / Math.pow(1024, d)).toFixed(c)) + " " + ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
}

export function addDays(date, days) {
    if (date === null) {
        return new Date();
    }
    if (days === null) {
        return date;
    }
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function removeDays(date, days) {
    if (date === null) {
        return new Date();
    }
    if (days === null) {
        return date;
    }
    let result = new Date(date);
    result.setDate(result.getDate() - days);
    return result;
}

export function diffDays(date1, date2) {
    if (!date1 || !date2) {
        return "--";
    }
    const diffTime = Math.abs(date2 - date1);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export function getCategoryByLabel(label, categories, filter = true) {
    return Object.values(categories).find(item =>
        normalizeText(item.label) === normalizeText(label));
}

export function normalizeText(string) {
    return string.toLowerCase()
        .replaceAll(" ", "_")
        .replaceAll("-", "_")
        .replaceAll("/", "_")
        .replaceAll("à", "a")
        .replaceAll("(", "_")
        .replaceAll(")", "_")
}

export function getSubcategoryByString(category, label) {
    return Object.values(category.subCategories).find(item =>
        normalizeText(item.label) === normalizeText(label));
}

export function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
}

export function isDateBetween(inizio, fine, dateToCompare) {
    let resultInizio = new Date(inizio).getTime();
    let result2 = new Date(dateToCompare).getTime();
    let resultFine = new Date(fine).getTime();
    return resultFine >= result2 && result2 >= resultInizio;
}

export function calculateAge(birthday) {
    let dateParts;

    // Controlla se la data è nel formato DD/MM/YYYY
    if (typeof birthday === 'string' && birthday.includes('/')) {
        dateParts = birthday.split('/');
        // Riordina la data nel formato YYYY-MM-DD
        birthday = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
    }

    let birthDate = new Date(birthday);
    if (isNaN(birthDate)) {
        return "BAD_DATE_ERROR";
    }

    let ageDifMs = Date.now() - birthDate.getTime();
    let ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export function removeDayDoDate(date, days) {
    return date.setDate(date.getDate() - days);
}

export function addDayToDate(date, days) {
    return date.setDate(date.getDate() + days);
}

export function addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
}

export function setZeroHoursToDate(date) {
    if (date && date !== "") {
        const stringToDate = new Date(date);
        if (stringToDate) {
            stringToDate.setHours(0);
            stringToDate.setMinutes(0);
            stringToDate.setSeconds(0);
            stringToDate.setMilliseconds(0);
            return stringToDate;
        } else {
            console.error("Data non valida... verificare");
            return null;
        }
    } else {
        console.error("La data non è valida, verifcare il dato", JSON.stringify(date));
        return null;
    }
}

export function camelCaseToSentence(text) {
    if (!text) return "";
    let sentence = text.replace(/([A-Z])/g, ' $1');
    return sentence.trim().charAt(0).toUpperCase() + sentence.trim().slice(1).toLowerCase();
}
